"use strict";

exports.__esModule = true;
exports.defaultOptions = exports.runQuery = exports.writeFile = undefined;

var _fs = require("fs");

var _fs2 = _interopRequireDefault(_fs);

var _pify = require("pify");

var _pify2 = _interopRequireDefault(_pify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withoutTrailingSlash = function withoutTrailingSlash(path) {
  return path === "/" ? path : path.replace(/\/$/, "");
};

var writeFile = exports.writeFile = (0, _pify2.default)(_fs2.default.writeFile);

var runQuery = exports.runQuery = function runQuery(handler, query, excludes) {
  return handler(query).then(function (r) {
    if (r.errors) {
      throw new Error(r.errors.join(", "));
    }

    // Removing exluded paths
    r.data.allSitePage.edges = r.data.allSitePage.edges.filter(function (page) {
      return !excludes.includes(withoutTrailingSlash(page.node.path));
    });

    return r.data;
  });
};

var defaultOptions = exports.defaultOptions = {
  query: "\n    {\n      site {\n        siteMetadata {\n          siteUrl\n        }\n      }\n\n      allSitePage {\n        edges {\n          node {\n            path\n          }\n        }\n      }\n  }",
  output: "/sitemap.xml",
  exclude: ["/dev-404-page", "/404", "/404.html", "/offline-plugin-app-shell-fallback"],
  createLinkInHead: true,
  serialize: function serialize(_ref) {
    var site = _ref.site,
        allSitePage = _ref.allSitePage;
    return allSitePage.edges.map(function (edge) {
      return {
        url: site.siteMetadata.siteUrl + edge.node.path,
        changefreq: "daily",
        priority: 0.7
      };
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/_gatsby-plugin-sitemap@1.2.20@gatsby-plugin-sitemap/internals.js
// module id = 255
// module chunks = 0